import React from 'react';
import { useSelector } from 'react-redux';
import { getSecurityUiConfig } from '../../../../base/config/functions.any';
import Dialog from '../../../../base/ui/components/web/Dialog';
import LobbySection from '../../../../lobby/components/web/LobbySection';
import { isEnablingLobbyAllowed } from '../../../../lobby/functions';
import PasswordSection from './PasswordSection';
/**
 * Component that renders the security options dialog.
 *
 * @returns {React$Element<any>}
 */
export default function SecurityDialog() {
    const disableLobbyPassword = useSelector((state) => getSecurityUiConfig(state)?.disableLobbyPassword);
    const _isEnablingLobbyAllowed = useSelector(isEnablingLobbyAllowed);
    return (React.createElement(Dialog, { cancel: { hidden: true }, ok: { hidden: true }, titleKey: 'security.title' },
        React.createElement("div", { className: 'security-dialog' },
            _isEnablingLobbyAllowed && React.createElement(LobbySection, null),
            !disableLobbyPassword && (React.createElement(React.Fragment, null,
                _isEnablingLobbyAllowed && React.createElement("div", { className: 'separator-line' }),
                React.createElement(PasswordSection, null))))));
}
